/* eslint-disable spire/export-styles */
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";
import { parseHtmlWithScriptRemoval } from "@MasterBluePrint/Overrides/Common/Utilities/parseHtmlContent";

const enum fields {
    contentIcon = "contentIcon",
    content = "content",
}

interface Props extends WidgetProps {
    fields: {
        [fields.contentIcon]: string;
        [fields.content]: string;
    };
}

export interface RichContentStyles {
    wrapper?: InjectableCss;
    phoneIcon?: InjectableCss;
}

const richContentStyles = {
    wrapper: {
        css: css`
            padding: .625rem 0 .625rem 0;

            .phone-link {
                font-family: "Lato", sans-serif;
                font-size: 1.25rem;
                vertical-align: middle;
                display: inline-block;
            }
        `
    },
    phoneIcon: {
        css: css`
            margin-right: .9375rem;
            line-height: 1;
            vertical-align: middle;
            display: inline-block;
        `
    },
};

export const SimpleHtmlContent: React.FunctionComponent<Props> = props => {
    if (!props.fields.content) {
        return null;
    }

    const styles = useMergeStyles("richContent", richContentStyles);

    return (
        <Typography as="div" {...styles.wrapper} className="phone-wrapper">  
            <Typography {...styles.phoneIcon} as="span">
                {parseHtmlWithScriptRemoval(props.fields.contentIcon)}
            </Typography>
            <a className="phone-link" href={`tel:${props.fields.content}`}>
                <Typography as="span">{props.fields.content}</Typography>
            </a>
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: SimpleHtmlContent,
    definition: {
        group: "Basic",
        icon: "Rtf",
        fieldDefinitions: [
            {
                name: fields.contentIcon,
                displayName: "Phone Icon",
                editorTemplate: "MultilineTextField",
                defaultValue: '<svg class="mob-ml-15  contact-icon" height="29" width="28" xmlns="http://www.w3.org/2000/svg"> <g fill="none" fill-rule="evenodd"> <path d="M23 8h-.06A9 9 0 005.06 8H5a5 5 0 000 10h2V9a7 7 0 1114 0v10a4 4 0 01-3.17 3.91 4 4 0 10.05 2A6 6 0 0023 19v-1a5 5 0 000-10zm-9 14a2 2 0 110 4 2 2 0 010-4zM5 10v6a3 3 0 010-6zm18 6v-6a3 3 0 010 6z" fill="#FFF"></path> <path d="M14 28a4 4 0 110-8 4 4 0 010 8z" fill="#FFB600"></path> <path d="M14 26a2 2 0 110-4 2 2 0 010 4z" fill="#FFF"></path> </g> </svg>',
                fieldType: "General",
            },
            {
                name: fields.content,
                displayName: "Phone Number",
                editorTemplate: "TextField",
                defaultValue: "+44 (0)1492 643 060",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;